export default __webpack_public_path__ + "static/media/4-2_image08@2x.3be0e79f.png";